"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = __importDefault(require("./styles"));
var Icon = function (_a) {
    var isHidden = _a.isHidden, className = _a.className, icon = _a.icon, style = _a.style, onClick = _a.onClick;
    if (isHidden)
        return null;
    var classNames = (className || '') + " " + (!!onClick ? 'clickable' : '') + " " + icon;
    return react_1.default.createElement(styles_1.default, { className: classNames, style: style, onClick: onClick });
};
exports.default = Icon;
//# sourceMappingURL=index.js.map